module.exports = __webpack_public_path__ + "img/1-1.39a3feb7.png";